import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-up-right', 'ArrowUpRight', [["path",{"d":"M17 7l-10 10"}],["path",{"d":"M8 7l9 0l0 9"}]]);